import type { FC } from "react";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { OrderPageV1 } from "./order-page/OrderPageV1";
import { OrderPageV2 } from "./order-page/v2/OrderPageV2";

export const OrderPage: FC = () => {
  const isThemeV2Enabled = useFeatureFlagEnabled("theme_v2");

  if (isThemeV2Enabled) {
    return <OrderPageV2 />;
  }

  return <OrderPageV1 />;
};
